import httpClient from "./httpClient.js";

export interface LoanRecord {
  id: number;
  partner: {
    id: number;
    person?: {
      firstName?: string;
      lastName?: string;
      secondLastName?: string;
    };
  };
  requestAmount: number | string;
  amountDiscount: number | string;
  startDayPay?: number; // unix seconds
  endDayPay?: number; // unix seconds
  note?: string;
  status: string;
  approved: boolean;
  isRejected: boolean;
  reviewerComment?: string;
  createdAt: string;
  updatedAt: string;
}

export interface LoanListParams {
  limit?: number;
  offset?: number;
  partnerId?: number;
  order?: "ASC" | "DESC";
  sort?: string;
  param?: string;
}

export const getLoanList = async (params: LoanListParams) => {
  const { data } = await httpClient.get("/loans", { params });
  return data as { data: LoanRecord[]; total: number };
};

export interface CreateLoanPayload {
  partnerId: number;
  requestAmount: number;
  amountDiscount: number;
  startDayPay?: number; // Unix timestamp
  endDayPay?: number; // Unix timestamp
  note?: string;
  status?: string;
  approved?: boolean;
  isRejected?: boolean;
  reviewerComment?: string;
}

export const createLoan = async (payload: CreateLoanPayload) => {
  const { data } = await httpClient.post("/loans", payload);
  return data as LoanRecord;
};

export const getLoanById = async (id: number) => {
  const { data } = await httpClient.get(`/loans/${id}`);
  return data as LoanRecord;
};

export const updateLoan = async (
  id: number,
  payload: Partial<CreateLoanPayload> & { status?: string }
) => {
  const { data } = await httpClient.patch(`/loans/${id}`, payload);
  return data as LoanRecord;
};

export const deleteLoan = async (id: number) => {
  const { data } = await httpClient.delete(`/loans/${id}`);
  return data as { message: string };
};

export const getLoanByPartner = async (partnerId: number) => {
  const { data } = await httpClient.get(`/loans/by-partner/${partnerId}`);
  return data as LoanRecord[];
};
